/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllMergedUsersModel } from './AllMergedUsersModel';
import {
    AllMergedUsersModelFromJSON,
    AllMergedUsersModelFromJSONTyped,
    AllMergedUsersModelToJSON,
    AllMergedUsersModelToJSONTyped,
} from './AllMergedUsersModel';
import type { JoinRequestCreatedResponse } from './JoinRequestCreatedResponse';
import {
    JoinRequestCreatedResponseFromJSON,
    JoinRequestCreatedResponseFromJSONTyped,
    JoinRequestCreatedResponseToJSON,
    JoinRequestCreatedResponseToJSONTyped,
} from './JoinRequestCreatedResponse';

/**
 * 
 * @export
 * @interface AddUserResponse
 */
export interface AddUserResponse {
    /**
     * 
     * @type {string}
     * @memberof AddUserResponse
     */
    status: string;
    /**
     * 
     * @type {AllMergedUsersModel}
     * @memberof AddUserResponse
     */
    user_data?: AllMergedUsersModel;
    /**
     * 
     * @type {JoinRequestCreatedResponse}
     * @memberof AddUserResponse
     */
    join_request?: JoinRequestCreatedResponse;
}

/**
 * Check if a given object implements the AddUserResponse interface.
 */
export function instanceOfAddUserResponse(value: object): value is AddUserResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function AddUserResponseFromJSON(json: any): AddUserResponse {
    return AddUserResponseFromJSONTyped(json, false);
}

export function AddUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'user_data': json['user_data'] == null ? undefined : AllMergedUsersModelFromJSON(json['user_data']),
        'join_request': json['join_request'] == null ? undefined : JoinRequestCreatedResponseFromJSON(json['join_request']),
    };
}

export function AddUserResponseToJSON(json: any): AddUserResponse {
    return AddUserResponseToJSONTyped(json, false);
}

export function AddUserResponseToJSONTyped(value?: AddUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'user_data': AllMergedUsersModelToJSON(value['user_data']),
        'join_request': JoinRequestCreatedResponseToJSON(value['join_request']),
    };
}

